import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2d0a0000")

_pushScopeId("data-v-2d0a0000")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Timesheet")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = { class: "nuovo_timesheet" }
const _hoisted_5 = {
  key: 0,
  class: "no_timesheet_container"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "no_timesheet" }, "Nessun timesheet inserito", -1)
const _hoisted_7 = {
  key: 1,
  class: "timesheets_container"
}
const _hoisted_8 = { class: "timesheet_info" }
const _hoisted_9 = { class: "first_row" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = {
  key: 0,
  class: "date"
}
const _hoisted_12 = {
  key: 1,
  class: "date"
}
const _hoisted_13 = { class: "note" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadTimesheets()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", {
                    class: "timesheet_button",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.openModal && $setup.openModal(...args)))
                  }, "Crea nuovo")
                ]),
                (!$setup.timesheets.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_5, [
                      _hoisted_6
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_7, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.timesheets, (timesheet) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "single_timesheet",
                          key: timesheet.timesheets_id
                        }, [
                          _createVNode("div", _hoisted_8, [
                            _createVNode("div", _hoisted_9, [
                              _createVNode("div", _hoisted_10, _toDisplayString($setup.setShortProject(timesheet.projects_name)), 1)
                            ]),
                            (_ctx.$showTimesheetDateHour == 'false')
                              ? (_openBlock(), _createBlock("div", _hoisted_11, _toDisplayString($setup.dateFormat(timesheet.timesheet_start_time)) + " - " + _toDisplayString(timesheet.timesheet_total_hours) + " ore ", 1))
                              : (_openBlock(), _createBlock("div", _hoisted_12, _toDisplayString($setup.dateFormat(timesheet.timesheet_start_time)) + ", " + _toDisplayString($setup.timeFormat(timesheet.timesheet_start_time)) + " - " + _toDisplayString($setup.timeFormat(timesheet.timesheet_end_time)), 1)),
                            _createVNode("div", _hoisted_13, _toDisplayString(timesheet.timesheet_note ? timesheet.timesheet_note : ""), 1)
                          ])
                        ]))
                      }), 128))
                    ]))
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})